module.exports = __webpack_public_path__ + "img/close.90466682.svg";